var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.config)?_c('highcharts',_vm._b({ref:"chart",staticClass:"chart"},'highcharts',_vm.config,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }